import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { WindowService } from '../../../shared/window.service';
import { FeedMetadataDetail } from '../shared/models/feed-metadata-detail.model';
import { GridSelectorDetail } from '../shared/models/grid-selector-detail.model';

@Injectable()
export class FeedGridService {

    private metadataDetailSubject = new Subject<FeedMetadataDetail>();
    private selectedGridRowsSubject = new Subject<any[]>();
    private selectedSelectListRowsSubject = new Subject<any[]>();
    private topFilterBoxSubject = new Subject<boolean>();

    metadataDetailObservable = this.metadataDetailSubject.asObservable();
    selectedGridRowsObservable = this.selectedGridRowsSubject.asObservable();
    selectedSelectListRowsObservable = this.selectedSelectListRowsSubject.asObservable();
    topFilterBoxObservable = this.topFilterBoxSubject.asObservable();

    constructor(private windowService: WindowService) { }

    setMetadataDetail(detail: FeedMetadataDetail) {
        this.metadataDetailSubject.next(detail);
    }

    setSelectedGridRows(rows: any[]) {
        this.selectedGridRowsSubject.next(rows);
    }

    setSelectListRows(rows: any[]) {
        this.selectedSelectListRowsSubject.next(rows);
    }

    setTopFilterBox(exists: boolean) {
        this.topFilterBoxSubject.next(exists);
    }

    openSelector(key: string, detail: GridSelectorDetail) {
        // stuff the details in the parent window for later before opening child
        // we will need this in the child
        if (detail) {
            window[key] = detail;
            this.windowService.openWindow(`/feed/${detail.config.feedKey}/selector?key=${key}`, 'feedSelectorPopup', 825, 510);
        }
    }

    updateParent(key: string, rows: any[]) {
        const detail = window.opener[key];
        detail.selectedRows = rows;
        window.opener[key] = detail;
        detail.parent.onSelectionsChanged(key, detail);
    }

    getDetailsFromParent() {
        const key = this.getParameterByName('key');
        if (key) {
            const detail = window.opener[key];
             // detail comes from a different window.  This will remove any implicit security context
            const replacer = [detail.config.sourceIdentityField, detail.config.sourceDisplayField];
            detail.selectedRows = JSON.parse(JSON.stringify(detail.selectedRows, replacer));
            return detail;
        }
        return undefined;
    }


    getParameterByName(name) {
        const url = window.location.href;
        name = name.replace(/[\[\]]/g, '\\$&');
        const regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
            results = regex.exec(url);
        if (!results) { return null; }
        if (!results[2]) { return ''; }
        return decodeURIComponent(results[2].replace(/\+/g, ' '));
    }
}



// WEBPACK FOOTER //
// ./src/app/main/feeds/shared/feed-grid.service.ts